import React from "react";

import "./Header.css";
import SubHeading from "../../components/SubHeading/SubHeading";
import { images } from "../../constants";
import useInView from "../../hooks/useInView";

const DOORDASH_URL =
  "https://www.doordash.com/store/pho-ha-long-san-antonio-41685551/103535348/?aw=hEV_jbHuzoPHt7HK";

const Header = () => {
  const [ref, isVisible] = useInView();

  return (
    <div className="app__header app__wrapper section__padding" id="home">
      <div
        ref={ref}
        className={`app__wrapper_info fade-in-section ${isVisible ? "visible" : ""}`}
      >
        <SubHeading title="Authentic Vietnamese Flavors" />
        <h1 className="app__header-h1">Pho Ha Long</h1>
        <p className="p__opensans" style={{ marginBottom: "2rem" }}>
          Welcome to Pho Ha Long. We aim to delight your taste buds using
          traditional techniques and the freshest ingredients. Join us for a
          casual and comfortable eating experience.
        </p>
        <div className="app__header-buttons">
          <button
            type="button"
            className="custom__button"
            onClick={() => {
              const menuEl = document.getElementById("menu");
              if (menuEl) {
                const navHeight = 80;
                const top =
                  menuEl.getBoundingClientRect().top + window.scrollY - navHeight;
                window.scrollTo({ top, behavior: "smooth" });
              }
            }}
          >
            Explore Menu
          </button>
          <a
            href={DOORDASH_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="custom__button custom__button--outline"
          >
            Order Delivery
          </a>
        </div>
      </div>

      <div className="app__wrapper_img">
        <img src={images.welcome} alt="Bowl of pho from Pho Ha Long" />
      </div>
    </div>
  );
};

export default Header;
